// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetEventByEventIdentifierRequestModel from '../../model/get-event-by-event-identifier-request-model';
import EventLookupRequestModel from '../../model/event-lookup-request-model';
import Tdg_EventModel from '../../model/tdg-event-model';
import GuidEventLookupListResultModel from '../../model/guid-event-lookup-list-result-model';

export default (service: Servicelayer) => ({
  /**  */
  async getEventByEventIdentifier(request: GetEventByEventIdentifierRequestModel, config?: RequestConfig) {
    const requestDTO = GetEventByEventIdentifierRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-event-by-event-identifier'] ?? 'tdg/widgets/events/{eventIdentifier}';
    endpointPath = endpointPath.replace(/\{eventIdentifier\}/g, `${requestDTO.eventIdentifier}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(Tdg_EventModel.toModel(dto));
  },
  /**  */
  async eventLookup(request: EventLookupRequestModel, config?: RequestConfig) {
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-event-lookup'] ?? 'tdg/admin/events/lookup';
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(GuidEventLookupListResultModel.toModel(dto));
  },
});
